module.exports = __webpack_public_path__ + "static/img/homeYellow.8ff3bc32.png";